export default __webpack_public_path__ + "static/media/YAS0720.34I-34467_-18882_0.7ac5709b.jpg";